import { useContext, createContext, useState, useEffect } from 'react';
import { CloudAlert, CircleX, CircleCheck } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

const ToasterContext = createContext();

export const ToasterProvider = ({ children }) => {
    const [toaster, setToaster] = useState({ message: null, statusCode: null });
   
    const addToaster = (message, statusCode) => {
        setToaster({ message: null, statusCode: null });
        setTimeout(() => {
            setToaster({ message, statusCode });
        }, 100);
    };
    
    const removeToaster = () => {

        setToaster({ message: null, statusCode: null });
    }
    
    const getToasterColors = (statusCode) => {
        statusCode = parseInt(statusCode);
        if (statusCode >= 500) return 'bg-red-600 text-white';
        if (statusCode >= 400) return 'bg-yellow-200 text-yellow-800';
        if (statusCode >= 200) return 'bg-green-500 text-white';
        return 'bg-blue-500 text-white';
    };
    
    const getToasterIcon = (statusCode) => {
        statusCode = parseInt(statusCode);
        if (statusCode >= 500) return <CloudAlert className="h-5 w-5 animate-pulse" />;
        if (statusCode >= 400) return <CircleX className="h-5 w-5 animate-pulse" />;
        if (statusCode >= 200) return <CircleCheck className="h-5 w-5 animate-pulse" />;
        return <div className="w-5 h-5 bg-white rounded-full animate-ping" />;
    };
    
    return (
        <ToasterContext.Provider value={{ addToaster, removeToaster }}>
            {children}
            <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50">
                <AnimatePresence>
                    {toaster.message && toaster.statusCode && (
                        <motion.div
                            key="toaster"
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 100 }}
                            transition={{ duration: 0.3 }}
                            className={`relative rounded-lg shadow-lg p-3 flex gap-5 items-center justify-between w-[250px] ${getToasterColors(toaster.statusCode)} font-bold`}
                        >
                            {getToasterIcon(toaster.statusCode)}
                            <div className="text-sm flex-grow">{toaster.message}</div>
                            
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </ToasterContext.Provider>
    );
};

export const useToaster = () => useContext(ToasterContext);
